import styled from 'styled-components';

import { fadeIn, preventTextSelection } from '../../../styles/shared.style';

export const Acordeon = styled.div<{ $show: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  opacity: 0;
  animation: ${({ $show }) => ($show ? fadeIn : 'bloc')} 1s forwards;
  border: 1px solid ${({ theme }) => theme.colors.border};
`;

export const Header = styled.div<{ $opened: boolean, $hasABackButton: boolean }>`
  display: flex;
  justify-content: ${({ $hasABackButton }) => $hasABackButton ? 'flex-start' : 'space-between'};
  align-items: center;
  padding: ${({ $hasABackButton }) => $hasABackButton ? '24px' : '10px 20px'};
  border-radius: ${({ $opened }) => ($opened ? '8px 8px 0 0' : '8px')};
  background-color: ${({ theme }) => theme.colors.surface.high};
  cursor: ${({ $hasABackButton }) => $hasABackButton ? 'pointer' : 'default'};
  overflow: hidden;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  margin-right: 16px;
  background-color: ${({ theme }) => theme.colors.surface.low};

  &:hover {
    background-color: ${({ theme }) => theme.colors.surface.low};
    cursor: pointer;
  }
`;

export const Title = styled.h2<{ $enabledSale: boolean }>`
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24.2px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  ${preventTextSelection()}

  color: ${({ theme : { colors }, $enabledSale }) => $enabledSale ? colors.text.primary : colors.button.text.disabled};

  @media (max-width: 1200px) {
    font-size: 14px;
  }
`;

export const ContentActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 95.5px;

  span {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    letter-spacing: 0.016em;
    text-align: left;
    color: ${({ theme }) => theme.colors.button.text.disabled};
  }
`;

export const ArrowAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.colors.surface.base};

  &:hover {
    cursor: pointer;
  }
`;

export const ShortlyText = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  line-height: 14.52px;
  letter-spacing: 0.016em;
  text-align: left;
  color: ${({ theme }) => theme.colors.button.text.disabled};
  ${preventTextSelection()}
`;

export const ErrorMessage = styled(ShortlyText)`
  color: ${({ theme }) => theme.colors.error};
  font-weight: 400;
  font-size: 12px;
`;

export const ContainerActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  justify-content: center;
`;

export const Content = styled.div<{ $opened: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: ${({ $opened }) => ($opened ? '1000px' : '0')};
  padding: ${({ $opened }) => ($opened ? '20px' : '0 20px 0 20px')};
  border-radius: 0 0 8px 8px;
  background-color: ${({ theme }) => theme.colors.surface.low};
  overflow: hidden;
  min-height: ${({ $opened }) => ($opened ? '80px' : '0')};
  gap: 12px;

  transition: max-height 0.5s ease, padding 0.5s ease;
  border-bottom: ${({ $opened, theme }) => ($opened ? `1px solid ${theme.colors.border}` : 'none')};
`;

export const RowFullWidth = styled.div<{ $handleTags?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 16px;
  align-items: center;

  @media (max-width: 1200px) {
    gap: 8px;
    flex-direction: ${({ $handleTags }) => ($handleTags ? 'column' : 'row')};
    align-items: ${({ $handleTags }) => ($handleTags ? 'flex-start' : 'center')};
  }
`;

export const TitleSection = styled.span<{ $enabled: boolean }>`
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24.2px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme, $enabled }) => ($enabled ? theme.colors.text.primary : theme.colors.button.text.disabled)};

  @media (max-width: 1200px) {
    font-size: 14px;
  }

  ${preventTextSelection()}
`;

export const WrapperTags = styled.div<{ $hasStartImage: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
`;

export const WrapperTitle = styled.div<{ $hasStartImage: boolean, $handleTags?: boolean }>`
  display: flex;
  flex-direction: ${({ $hasStartImage }) => ($hasStartImage ? 'column' : 'row')};
  justify-content: center;
  gap: 12px;
  overflow: hidden;
  
  @media (max-width: 1200px) {
    gap: 8px;
    flex-direction: ${({ $handleTags }) => ($handleTags ? 'column' : 'row')};
    align-items: ${({ $handleTags }) => ($handleTags ? 'flex-start' : 'center')};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const Description = styled.span<{ $enabled: boolean; $height: number }>`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${({ theme, $enabled }) => ($enabled ? theme.colors.text.secondary : theme.colors.button.text.disabled)};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 40px;
  transition: max-height 0.5s ease-in-out;

  @media (max-width: 1200px) {
    font-size: 12px;
  }
`;

export const TransferableText = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  text-align: left;
  color: #454F5B;
`;

export const TaxedText = styled.span`
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 12.1px;
  letter-spacing: 0.016em;
  text-align: left;
  text-decoration-line: line-through;
  color: ${({ theme }) => theme.colors.button.text.disabled};
  margin-bottom: -10px;
`;

export const ValueText = styled.span<{ $enabled: boolean }>`
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  letter-spacing: 0.016em;
  text-align: left;
  color: ${({ theme, $enabled }) => ($enabled ? theme.colors.text.primary : theme.colors.button.text.disabled)};
  ${preventTextSelection()}

  @media (max-width: 1200px) {
    font-size: 14px;
  }
`;

export const ValueInfoText = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.016em;
  text-align: left;
  margin-left: -8px;
  color: ${({ theme }) => theme.colors.button.text.disabled};
  ${preventTextSelection()}
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const Quantity = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  letter-spacing: 0.016em;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};

  ${preventTextSelection()}
`;

export const Selector = styled.div<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: transparent;
  ${preventTextSelection()}

  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  span {
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.36px;
    letter-spacing: 0.016em;
    text-align: center;
    color: ${({ theme }) => theme.colors.surface.high};
  }
`;

export const ToggleExpanded = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  padding: 0;
  margin: 0;
  height: 20px;
  min-width: 50px;
  
  ${preventTextSelection()}

  &:hover {
    cursor: pointer;
    background-color: transparent;
  }

  & span {
    font-family: Inter;
    font-size: 11px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: ${({ theme }) => theme.colors.accent.primary};
  }
`;

export const WrapperExpanded = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const ViewMoreTextModal = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.2px;
  text-align: left;
`;

export const QtdeInStock = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.2px;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
